import { render, staticRenderFns } from "./CompletedAnalysesMenu.vue?vue&type=template&id=38fcd935&"
import script from "./CompletedAnalysesMenu.vue?vue&type=script&lang=ts&"
export * from "./CompletedAnalysesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CompletedAnalysesMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports